module.exports = __webpack_public_path__ + "static/fipcbluewhale4-61eb0dca71d6ead25558aaff5312af0d.jpeg";